const BASE = process.env.REACT_APP_API_URL || "";

async function request(path, options = {}) {
  const token = localStorage.getItem("masters_token");
  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.detail || "Request failed");
  return data;
}

const api = {
  get: (path) => request(path),
  post: (path, body) => request(path, { method: "POST", body: JSON.stringify(body) }),

  auth: {
    register: (u, e, p, phone) => request("/api/auth/register", {
      method: "POST", body: JSON.stringify({ username: u, email: e, password: p, phone })
    }),
    login: (u, p) => request("/api/auth/login", {
      method: "POST", body: JSON.stringify({ username: u, password: p })
    }),
    me: () => request("/api/auth/me"),
    forgotPassword: (email) => request("/api/auth/forgot-password", {
      method: "POST", body: JSON.stringify({ email })
    }),
    resetPassword: (token, password) => request("/api/auth/reset-password", {
      method: "POST", body: JSON.stringify({ token, password })
    }),
  },
  golfers: {
    list: () => request("/api/golfers"),
  },
  teams: {
    submit: (team_name, golfer_ids, team_id = null) =>
      request("/api/teams/submit", {
        method: "POST",
        body: JSON.stringify({ team_name, golfer_ids, ...(team_id !== null ? { team_id } : {}) }),
      }),
    my: () => request("/api/teams/my"),
    get: (id) => request(`/api/teams/${id}`),
  },
  leaderboard: {
    get: () => request("/api/leaderboard"),
  },
  settings: {
    get: () => request("/api/settings"),
  },
  admin: {
    lockTeams:    () => request("/api/admin/lock-teams", { method: "POST" }),
    unlockTeams:  () => request("/api/admin/unlock-teams", { method: "POST" }),
    refresh:      () => request("/api/admin/refresh-scores", { method: "POST" }),
    users:        () => request("/api/admin/users"),
    updateGolfer: (body) =>
      request("/api/admin/update-golfer", { method: "POST", body: JSON.stringify(body) }),
    setRound:     (n) => request(`/api/admin/set-round?round_num=${n}`, { method: "POST" }),
    deleteTeams: (team_ids) => request("/api/admin/delete-teams", { method: "POST", body: JSON.stringify({ team_ids }) }),
    setTournamentComplete: (complete) =>
      request(`/api/admin/set-tournament-complete?complete=${complete}`, { method: "POST" }),
    clearTeams: () => request("/api/admin/clear-teams", { method: "POST" }),
    clearScores: () => request("/api/admin/clear-scores", { method: "POST" }),
    resetGolfers: () => request("/api/admin/reset-golfers", { method: "POST" }),
    syncRankings: () => request("/api/admin/sync-rankings", { method: "POST" }),
    setPot: (amount) => request(`/api/admin/set-pot?amount=${amount}`, { method: "POST" }),
    setTheme: (theme) => request(`/api/admin/set-theme?theme=${theme}`, { method: "POST" }),
    setPaid: (user_id, paid) => request(`/api/admin/set-paid?user_id=${user_id}&paid=${paid}`, { method: "POST" }),
  },
};

export { api };